import React, { useState, useEffect } from "react";
import ViewUploadedRate from "../Components/ViewUploadedRate";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const ViewUploadedRateAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Header />
      <Sidebar />
      <ViewUploadedRate />
    </>
  );
};

export default ViewUploadedRateAdmin;
